import { Pipe, PipeTransform } from '@angular/core';
import { FormattedNumberPipe } from './formatted-number.pipe';
import { MomentPipe } from './moment.pipe';
import { Placeholder } from '../models/placeholder.model';
import { PlaceholderPipe } from '../models/placeholder-pipe.model';
import { LocalizationService } from '../services/localization.service';

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {

    constructor(private service: LocalizationService, private numberPipe: FormattedNumberPipe, private momentPipe: MomentPipe) { }

    transform(code: string, locale: string, placeholders?: Placeholder[]): string {
        let text = this.service.getTranslationsMap().get(code) || '';

        if (placeholders) {
            for (const placeholder of placeholders) {
                const updatedText = this.replacePlaceholder(text, placeholder, locale);

                if (updatedText === null) {
                    return '';
                }

                text = updatedText;
            }
        }

        return text
    }

    private replacePlaceholder(text: string, placeholder: Placeholder, locale: string): string | null {
        const regex = new RegExp(`\\$\\{${this.escapeRegExp(placeholder.getName())}\\}`, 'g');
        let value = placeholder.getValue();

        if (value == null && regex.test(text)) {
            return null;
        }

        if (placeholder.getPipe()) {
            value = this.transformValueWithPipe(placeholder.getPipe()!, value, locale);
        }

        const isBold = placeholder.getBold();
        return text.replace(regex, `${isBold ? '<strong>' : ''}${value}${isBold ? '</strong>' : ''}`);
    }

    private escapeRegExp(string: string): string {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    private transformValueWithPipe(pipe: PlaceholderPipe, value: Date | number | string, locale: string): string | null {
        switch (pipe.getType()) {
            case PlaceholderPipe.Type.DATE:
                return this.momentPipe.transform(Number(value), pipe.getParams(), locale);
            case PlaceholderPipe.Type.LOCAL_DATE:
                return this.momentPipe.transform(Number(value), pipe.getParams(), locale, true);
            case PlaceholderPipe.Type.NUMBER:
                return this.numberPipe.transform(Number(value), locale);
            default:
                return String(value);
        }
    }

}